import { YIELD_ROWS } from "../controleConstants";
import { CHARTER_THEME } from "../controleTheme";
import { documentCardStyle, lotReleaseBodyCellStyle, lotReleaseHeaderCellStyle } from "../styles/reportStyles";

export function YieldReport({ value, onChange }) {
    const { inputStyle } = CHARTER_THEME;
    const data = value || {};

    const updateField = (key, nextValue) => {
        onChange({ ...data, [key]: nextValue });
    };

    const updateRow = (key, patch) => {
        onChange({
            ...data,
            rows: {
                ...(data.rows || {}),
                [key]: {
                    ...((data.rows || {})[key] || {}),
                    ...patch,
                },
            },
        });
    };

    return (
        <div style={documentCardStyle}>
            <div style={{ color: "#0f172a", fontSize: "22px", fontWeight: 950 }}>RENDEMENT :</div>
            <div style={{ overflowX: "auto", border: "1px solid #cbd5e1", borderRadius: "8px", background: "white" }}>
                <table style={{ width: "100%", minWidth: "760px", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ background: "#f8fafc" }}>
                            <th style={lotReleaseHeaderCellStyle}>PATIENT</th>
                            <th style={{ ...lotReleaseHeaderCellStyle, width: "220px" }}>NOMBRE</th>
                            <th style={{ ...lotReleaseHeaderCellStyle, width: "190px" }}>VISA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {YIELD_ROWS.map(([key, label]) => {
                            const row = (data.rows || {})[key] || {};
                            return (
                                <tr key={key}>
                                    <td style={{ ...lotReleaseBodyCellStyle, fontWeight: 800 }}>{label}</td>
                                    <td style={lotReleaseBodyCellStyle}>
                                        <input
                                            style={{ ...inputStyle, width: "100%" }}
                                            value={row.nombre || ""}
                                            onChange={event => updateRow(key, { nombre: event.target.value })}
                                            placeholder="Nombre"
                                        />
                                    </td>
                                    <td style={lotReleaseBodyCellStyle}>
                                        <input
                                            style={{ ...inputStyle, width: "100%" }}
                                            value={row.visa || ""}
                                            onChange={event => updateRow(key, { visa: event.target.value })}
                                            placeholder="Visa"
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div style={{
                display: "grid",
                gap: "14px",
                padding: "14px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                background: "#f8fafc",
            }}>
                <label style={{ display: "grid", gap: "7px" }}>
                    <span style={{ color: "#0f172a", fontSize: "14px", fontWeight: 900 }}>Commentaire/autre problème</span>
                    <textarea
                        style={{ ...inputStyle, width: "100%", minHeight: "86px", resize: "vertical", lineHeight: 1.45 }}
                        value={data.commentaireAutre || ""}
                        onChange={event => updateField("commentaireAutre", event.target.value)}
                        placeholder="Commentaire"
                    />
                </label>
                <div style={{ display: "grid", gridTemplateColumns: "minmax(220px, 1fr) minmax(220px, 1fr)", gap: "12px" }}>
                    <label style={{ display: "grid", gap: "6px" }}>
                        <span style={{ color: "#334155", fontSize: "13px", fontWeight: 900 }}>Nom :</span>
                        <input
                            style={{ ...inputStyle, width: "100%" }}
                            value={data.nom || ""}
                            onChange={event => updateField("nom", event.target.value)}
                            placeholder="Nom"
                        />
                    </label>
                    <label style={{ display: "grid", gap: "6px" }}>
                        <span style={{ color: "#334155", fontSize: "13px", fontWeight: 900 }}>Signature Pharmacien:</span>
                        <input
                            style={{ ...inputStyle, width: "100%" }}
                            value={data.signaturePharmacien || ""}
                            onChange={event => updateField("signaturePharmacien", event.target.value)}
                            placeholder="Signature"
                        />
                    </label>
                </div>
            </div>
        </div>
    );
}
